<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav5_blue.svg" alt="">ソリューション</h1>
      <ul class="l-solutionList">
        <li class="l-solutionList__item" v-for="solution in solutionList" :key="solution.solutionId" @click="goDetail(solution.solutionId)">
          <a>
            <div class="l-solutionList__img" :style="'background-image: url(' + solution.thumbNailImageFile + ');'"></div>
            <p class="l-solutionList__title">{{ solution.name }}</p>
            <p class="l-solutionList__text" style="overflow-wrap: normal; word-break: break-all; white-space: pre-line;">{{ solution.descriptionForList }}</p>
          </a>
        </li>
      </ul>
      <pagination
        :pageInfo="pageInfo"
        @change-page="emitChangePage">
      </pagination>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';

export default {
  components: {
    Loading,
    Pagination,
  },
  data() {
    return {
      isProcessing: false,
      pageInfo: {},
      solutionList: []
    }
  },
  created: function () {
    this.getSolutionList(1);
  },
  methods: {
    emitChangePage(page) {
      this.getSolutionList(page)
    },
    async getSolutionList(page) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/solution/getSolutionList', {
        page: page,
        excludeInvisible: true,
      });
      if (res) {
        this.solutionList = res.data.solutionList.data;
        this.pageInfo = {
          currentPage: res.data.solutionList.currentPage,
          lastPage: res.data.solutionList.last_page,
          total: res.data.solutionList.total,
          from: res.data.solutionList.from,
          to: res.data.solutionList.to,
        };
      }
      this.isProcessing = false;
    },
    goDetail(solutionId) {
      this.$store.dispatch('solution/setSolutionId', solutionId);
      this.$router.push({ name: 'solution-detail' } );
    }
  }
}

</script>
